import { ActionIcon, Button, Modal, ModalProps, Stack } from 'ui';
import { useDisclosure } from 'ui/Hooks';
import { IconFilter } from 'ui/Icons';

import { SortSelect } from './SearchFilters';

type FilterModalProps = ModalProps;

const FilterModal = ({ opened, onClose }: FilterModalProps) => {
  return (
    <Modal keepMounted title={'Filter Merchant Offers'} opened={opened} onClose={onClose}>
      <Stack gap={'lg'}>
        <SortSelect />
        <Button fullWidth onClick={onClose}>
          Apply Filters
        </Button>
      </Stack>
    </Modal>
  );
};

const FilterModalButton = () => {
  const [opened, handlers] = useDisclosure(false);
  return (
    <>
      <ActionIcon
        variant="gray"
        onClick={handlers.open}
        // Z-index is set to 2 to ensure the icon is above the grab handle when present
        style={{ zIndex: 2 }}
      >
        <IconFilter />
      </ActionIcon>
      <FilterModal opened={opened} onClose={handlers.close} />
    </>
  );
};

export { FilterModalButton };
